import inventoryAPI from '@/services/API/inventory'
import { Message } from 'element-ui';

const fetchInventories = function({ commit,state }) {
  if(state.outdated){
    return inventoryAPI.getInventories().then(inventories => {
      commit('SET_INVENTORIES', inventories);
      return inventories;
    });
  }
  return Promise.resolve(state.inventories);

};

const invalidateInventories = function ({commit}){
  commit('INVALIDATE_INVENTORIES');
}

const updateInventory = function({commit, dispatch}, inventory){

  return inventoryAPI.updateInventory(inventory)
    .then(()=>{
      dispatch('invalidateInventories');
      Message.success({message: "L'inventaire a été modifié avec succès!"});
      return true;
    }).catch(err=>{
      Message.error({message : "Oups... une erreur s'est produite. Veuillez réessayer plus tard."})
      return false;
    })
}

const createInventory = function({commit, dispatch}, inventory){
  return inventoryAPI.createInventory(inventory)
    .then(inventory=>{
      dispatch('invalidateInventories');
      Message.success({message: "L'inventaire a été ajouté avec succès!"});
      return true;

    }).catch(err=>{
      Message.error({message : "Oups... une erreur s'est produite. Veuillez réessayer plus tard."})
      return false;
    })
}





export default {
  fetchInventories,
  invalidateInventories,
  updateInventory,
  createInventory
};
